export const LOGIN_ROUTES = {
  SELECTION_SCREEN: '/',
  PASSWORD_SCREEN: '/password',
  OTP_SCREEN: '/otp',
  OTP_CODE_SCREEN: '/otp/code',
  FORGET_PASSWORD_SCREEN: '/forget-password',
};
